<!--
 * @Author: Tina Huang
 * @Date: 2022-09-25 19:59:35
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-06-15 20:57:14
 * @Description: 
-->
<template>
  <div class="lib-container">
    <h2>系统公告</h2>
    <div class="news-list">
      <CardItem v-for="item in list" :key="item.datetime">
        <h3>
          <el-tag :type="type[item.type].style">{{
            type[item.type].label
          }}</el-tag
          >{{ item.title }}
        </h3>
        <div v-html="item.msg"></div>
        <p class="date">{{ item.datetime }}</p>
      </CardItem>
    </div>
  </div>
</template>
<script>
import CardItem from "@/components/comp/card-item.vue";
export default {
  components: { CardItem },
  data() {
    return {
      list: [],
      type: {
        update: {
          label: "迭代更新",
          style: "success",
        },
        others: {
          label: "QA",
          style: "error",
        },
      },
    };
  },
  mounted() {
    this.getDatas();
  },
  methods: {
    getDatas() {
      const _this = this;
      this.$axios.get(`./news.json?v=${Math.random()}`).then((res) => {
        let list = res.data.news.filter((news) => news.show);
        _this.list = list;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.lib-container {
  padding: 5vw;
  padding-top: 120px;
  min-height: 70vh;
  h2 {
    font-size: 30px;
    text-align: center;
  }
}
.item {
  h3 {
    font-size: 25px;
    text-align: center;
    span {
      margin-right: 10px;
    }
  }
  div,
  p {
    font-size: 18px;
    &.date {
      text-align: right;
      margin-top: 20px;
    }
  }
  ::v-deep img {
    max-width: 100% !important;
    display: block;
  }
}
</style>
